import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

export default function FeaturedSection() {
  const { t } = useTranslation();

  return (
    <section id="featured" className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
        <div className="order-2 lg:order-1">
          <span className="inline-block rounded-full bg-accent-100 px-3 py-1 text-xs font-bold uppercase tracking-wider text-accent-900">
            {t("nav.spreadsheet")}
          </span>
          <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">{t("featured.title")}</h2>
          <p className="mt-4 max-w-lg text-base leading-relaxed text-foreground-600">{t("featured.text")}</p>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-accent-600"
          >
            {t("featured.cta")}
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-base" aria-hidden="true"></i>
            </span>
          </a>
        </div>

        <div className="order-1 lg:order-2">
          <div className="overflow-hidden rounded-3xl border border-background-200">
            <div className="h-64 w-full md:h-80">
              <img
                src="https://readdy.ai/api/search-image?query=A%20carefully%20styled%20flat%20lay%20of%20folded%20pastel%20clothing%2C%20sneakers%2C%20a%20cap%20and%20a%20small%20bag%20arranged%20on%20a%20warm%20cream%20surface%2C%20soft%20overhead%20natural%20light%2C%20minimal%20fashion%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=800&height=640&seq=featured-01&orientation=landscape&nocache=true"
                alt="USFans spreadsheet resource"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}